export default "/fonts/Poppins-Bold.ttf?b1c32aa57ad5bc9998dddd0131296064";